import { createIdentifier } from '@blocksuite/global/di';

import type { EdgelessCRUDExtension } from './crud-extension';

export const EdgelessCRUDIdentifier = createIdentifier<EdgelessCRUDExtension>(
  'AffineEdgelessCrudService'
);
